import { render, staticRenderFns } from "./DownloadPDFButton.vue?vue&type=template&id=4fec4d98"
import script from "./DownloadPDFButton.vue?vue&type=script&lang=js"
export * from "./DownloadPDFButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports